import { PrimaryDivision, Participant } from "./types";
import config from "../../../config";
import fetchWithAuth from '../../../services/fetchWithAuth';  

const BASE_API = config.API_BASE_URL;

export const fetchParticipants = async (
  accountID: number
): Promise<Participant[]> => {
  try {
    const response = await fetchWithAuth(
      `${BASE_API}account/account-profiles/${accountID}`
    );
    const apiData = await response.json();
    return Array.isArray(apiData) ? apiData : [];
  } catch (error) {
    console.error("Failed to fetch participants", error);
    return [];
  }
};

export const fetchDivisions = async (
  fundraiserID: number
): Promise<PrimaryDivision[]> => {
  try {
    const response = await fetchWithAuth(
      `${BASE_API}division/fundraiser/${fundraiserID}`
    );
    if (!response.ok) throw new Error("Failed to fetch divisions");
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Failed to fetch divisions", error);
    return [];
  }
};

export const fetchSupportEmail = async (): Promise<string | null> => {
  try {
    const response = await fetch(`${BASE_API}config-options/support_email`);
    if (response.ok) {
      const data = await response.json();
      return data[0]?.config_value || null;
    }
    throw new Error("Network response was not ok");
  } catch (error) {
    console.error("Failed to fetch support email", error);
    return null;
  }
};
